import React from 'react';
import ScheduleBuilderTab from '../../tournament_formats/ScheduleBuilderTab';

/**
 * Thin per-tournament wrapper around the new schedule-generation module
 * (src/tournament_formats/ScheduleBuilderTab.jsx, see KYN-475) — its own tab
 * file, mirroring every other tab under tournaments/tabs/, rather than
 * inlined in TournamentDetailPage.jsx. Deliberately separate from the
 * "Matches" tab (ScheduleTab.jsx), which is the older, frozen
 * tournamentScheduleGenerator.js stack and keeps running unchanged.
 */
const SmartScheduleTab = ({ tournament, participantsSummary, onOpenLiveTab, activeTab }) => (
  <ScheduleBuilderTab tournament={tournament} participantsSummary={participantsSummary} onOpenLiveTab={onOpenLiveTab} activeTab={activeTab} />
);

export default SmartScheduleTab;
